<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_master_maker_detail</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot title="棚卸業務" ></title-and-slot>
        <div class="row">
          <div class="col-xs-12 clearfloat">
            <div class="form1 col-xs-6" style="max-width:650">
            <div class="row"  style="margin-bottom: 5px;"> 
              <label class="col-xs-3 control-label esma_form_label">会社</label>
              <select 
              class="select-box"
              :value = "selvalues[Searchmap('company')]"
              :disabled = "selectdisable['company']" 
              :readonly = "selectreadonly['company']" 
              @change="SelectSearch({id:'company',value:$event.target.value})">
                <option v-if="EditableUser == true"></option>
                <option v-for="r in companylist" :key="r.val" :value="r.val">{{r.val}}</option>
              </select>
            </div>

            <div class="row"  style="margin-bottom: 5px;"> 
              <label class="col-xs-3 control-label esma_form_label" style ="margin-right:10px">部署</label>
              <select 
              class="select-box"
                :value = "selvalues[Searchmap('department')]"
                :disabled = "selectdisable['department']"
                :readonly = "selectreadonly['department']" 
                @change="SelectSearch({id:'department',value:$event.target.value})">
                <option v-if="EditableUser == true"></option>
                <option v-for="r in departmentlist" :key="r.val" :value="r.val">{{r.val}}</option>
              </select>
            </div>

            <div class="row"  style="margin-bottom: 5px;"> 
              <label class="col-xs-3 control-label esma_form_label">チーム</label>
              <select 
                 class="select-box"
                :value = "selvalues[Searchmap('team')]"
                :disabled = "selectdisable['team']" 
                :readonly = "selectreadonly['team']"             
                @change="SelectSearch({id:'team',value:$event.target.value})">
              <option ></option>
              <option v-for="r in teamlist" :key="r.val" :value="r.val">{{r.val}}</option>
             </select>
            </div>

            <div class="row"  style="margin-bottom: 5px;"> 
              <label class="col-xs-3 control-label esma_form_label">所管区分</label>
              <select 
                 class="select-box"
                :value = "selvalues[Searchmap('jurisdiction_classification')]"
                :disabled = "selectdisable['jurisdiction_classification']" 
                :readonly = "selectreadonly['jurisdiction_classification']" 
                @change="SelectSearch({id:'jurisdiction_classification',value:$event.target.value})">
                <option ></option>
                <option v-for="r in classificationlist" :key="r.val" :value="r.val">{{r.val}}</option>
              </select>
            </div>

            <div class="row"  style="margin-bottom: 5px;"> 
              <label class="col-xs-3 control-label esma_form_label">システム</label>
              <select 
                class="select-box"
                :value = "selvalues[Searchmap('system')]"
                :disabled = "selectdisable['system']"
                :readonly = "selectreadonly['system']"             
                @change="SelectSearch({id:'system',value:$event.target.value})">
              <option ></option>
              <option v-for="r in systemlist" :key="r.val" :value="r.val">{{r.val}}</option>
            </select>
            </div>


              <div class="row"  style="margin-top: 10px;margin-bottom: 5px;"> 
                <button
                class="btn btn-primary" style="min-width:70px;height: 32px; font-size : 15px ;float: right;background: #FF7C80;;background: #337ab7;" 
                @click="searchclear"
                >クリア</button>
             </div>
           </div>
              <!-- <field-box   
                v-for="f in formFields.col0"  
                v-bind:key="f.id" v-bind:data="f"  
                :read="readOnly" 
                @on_update="onSearchValue" 
                :val="values[f.id]"></field-box>
            </div> -->
            <!-- <div 
            v-if="group0Error != false"
            style="color: red;padding: 10px;font-weight: 900;"
            v-html="group0Error"
            ></div> -->

          <div class="col-xs-1" style="width:5%"></div>
          <div class="col-xs-4" style="margin-top:40px;width:40%">
            <inventory-summary-box 
              :t1="counterT1"
              :t2="counterT2"
              :t3="counterT3"
              :t4="counterT4"
              :b1="counterB1"
              :b2="counterB2"
              :b3="counterB3"
              :b4="counterB4"
              :u4="counterU4"
              style="float: right;"/>
          </div>
          
          </div>
        <div class="row">
          <div class="col-xs-12" >
            <tabs nav-style="tabs" @active="onTabChanged($event)" :value="selectedTab">
              <tab header="証書一覧" ></tab>
              <tab header="機器・ソフトウェア紐付け明細" ></tab>    
            </tabs>
          </div>           
        </div>      
        <div style="margin-bottom:30px;">
          <div v-if="selectedTab == 0"  ><inventory-certificate-list ref="inventorycertificatelistsubpage" :searchData="inventory_sub_search" /></div>
          <div v-else-if="selectedTab == 1"  style="top:-30p;"><inventory-pending-items ref="inventorypendingitemssubpage" :searchData="inventory_sub_search" /></div>
        </div>
      </div>
      </div>      
      <confirmation-modal tag="confirmInventorySave" @done="onInventorySaveCondirmed" />
      <confirmation-modal tag="confirmInventoryExport" @done="onInventoryExportCondirmed" />
      <file-download-modal tag="runInventoryExportDownloadModal" @close="onCloseExportFile"/>
  </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';
import { fields, filed_types } from '@/rules/fields_inventory_report';　
import { fields as cert_fields } from '@/rules/fields_certificate_software';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:inventory_report');
import fieldBoxes from '@/components/form-field';
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import inventorySummaryBox from "@/components/inventory_summary_box";
import fileDownloadModal from '@/components/modals/file-download-modal';
import { bus } from '@/libs/bus';

import inventoryCertificateList from '@/components/sub_pages/inventory_certificate_list';
import inventoryManagement from '@/components/sub_pages/inventory_management';
import inventoryPendingItems from '@/components/sub_pages/inventory_pending_items';
import constants from "@/rules/constants";
import { tab, tabs } from "vue-strap/dist/vue-strap.js";

var timeout_control = {};
var queue_bus = []

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'field-box': fieldBoxes,
    "inventory-summary-box":inventorySummaryBox,
    'file-download-modal':fileDownloadModal,
    "inventory-management":inventoryManagement,
    "inventory-certificate-list":inventoryCertificateList,
    "inventory-pending-items":inventoryPendingItems,
    "inventory-summary-box":inventorySummaryBox,
    tab,
    tabs
  },
  data() {
    return {
      api_name:"inventory_report",
      page_acl: acl.inventory_report,
      selected_tab:0,
      inventory_sub_search :{},
      counter_b1:"",
      counter_b2:"",
      counter_b3:"",
      counter_b4:"",
      counter_t1:"",
      counter_t2:"",
      counter_t3:"",
      counter_t4:"",
      counter_u4:"",      
      counter_b3_error_message:null,
      // reporting_period_list:[],
      //search
      use_key:"cert",
      select_list:{
        company:[],
        department:[],
        jurisdiction_classification:[],
        system:[],
        team:[]
        },
      select_disable:{
        company:false,
        department:false,
        jurisdiction_classification:false,
        system:false,
        team:false
        },
      select_readonly:{
        company:false,
        department:false,
        jurisdiction_classification:false,
        system:false,
        team:false
        },
      select_mode:"",
      search_map:false,
      reverse_map:false,      
      //search End
      allow_to_submit:false,
      // group_0_error:false,
      page_mode:0,
      saved_seq_id :-1,
    };
  },
  computed: {
    //search
    selvalues(){
      return this.inventory_sub_search;
    },
    selectdisable(){
      return this.select_disable;
    },
    selectreadonly(){
      return this.select_readonly;
    },
    companylist:{
      get(){
        return this.select_list.company;
      },
      set(v){
        this.select_list.company = v;
      }
    },
    selectmode:{
      get(){
        return this.select_mode;
      },
      set(v){
        this.select_mode = v;
        this.onselectmode(v);
      }
    },
    departmentlist:{
      get(){
        return this.select_list.department;
      },
      set(v){
        this.select_list.department = v;
      }
    },
    classificationlist:{
      get(){
        return this.select_list.jurisdiction_classification;
      },
      set(v){
        this.select_list.jurisdiction_classification = v;
      }
    },
    systemlist:{
      get(){
        return this.select_list.system;
      },
      set(v){
        this.select_list.system = v;
      }
    },
    teamlist:{
      get(){
        return this.select_list.team;
      },
      set(v){
        this.select_list.team = v;
      }
    },
    selectedTab:{
      get(){
        return this.selected_tab;
      },
      set(v){
        this.selected_tab = v;
      }
    },
  //search End

    // group0Error:{
    //   get(){
    //     return this.group_0_error;
    //   },
    //   set(v){
    //     this.group_0_error = v;
    //   }
    // },
    allowToSubmit:{
      get(){
        return this.allow_to_submit;
      },
      set(v){
        this.allow_to_submit = v;
      }
    },
    // reportingPeriodList:{
    //   get(){
    //     return this.reporting_period_list;
    //   },
    //   set(v){
    //     this.reporting_period_list = v;
    //   }
    // },
    counterB3ErrorMessage:{
      get(){
        return this.counter_b3_error_message;
      },
      set(v){
        this.counter_b3_error_message = v;
      }
    },
    counterT1:{
      get(){
        return ""+this.counter_t1;
      },
      set(v){
        this.counter_t1 = v;
      }
    },
    counterT2:{
      get(){
        return ""+this.counter_t2;
      },
      set(v){
        this.counter_t2 = v;
      }
    },
    counterT3:{
      get(){
        return ""+this.counter_t3;
      },
      set(v){
        this.counter_t3 = v;
      }
    },
    counterT4:{
      get(){
        return ""+this.counter_t4;
      },
      set(v){
        this.counter_t4 = v;
      }
    },
    counterB1:{
      get(){
        return ""+this.counter_b1;
      },
      set(v){
        this.counter_b1 = v;
      }
    },
    counterB2:{
      get(){
        return ""+this.counter_b2;
      },
      set(v){
        this.counter_b2 = v;
      }
    },
    counterB3:{
      get(){
        return ""+this.counter_b3;
      },
      set(v){
        this.counter_b3 = v;
      }
    },
    counterB4:{
      get(){
        return ""+this.counter_b4;
      },
      set(v){
        this.counter_b4 = v;
      }
    },
    counterU4:{
      get(){
        return ""+this.counter_u4;
      },
      set(v){
        this.counter_u4 = v;
      }
    },
    EditableUser(){
      return ((Vue.localStorage.get("userRole")== constants.PERMISSION.SYSTEM_ADMINISTRATOR 
      || Vue.localStorage.get("userRole") == constants.PERMISSION.MAINTENANCE_STAFF))
      && Vue.localStorage.get("userCompany") == "ライセンス管理窓口";
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    formFields() {
      return {
        col0:[
        ],
      }
    },
    certsearchkeys(){
      return ["company",
        "jurisdiction_classification",
        "licensed_department",
        "license_jurisdiction_team",
        "license_jurisdiction_system"]
    },
    searchkeys(){
      return ["company",
        "jurisdiction_classification",
        "department",
        "team",
        "system"]
    },

    
  },
  methods: {
    //search
    searchclear(){
      if(this.EditableUser == true){
        this.selectmode = "";
        this.inventory_sub_search[this.Searchmap("company")] = "";
      }else{
        this.selectmode = "department";   
      }

    },
    presetListSelectBox(){
      if(this.EditableUser == true){
          this.$ajax.post_cached_queued( "/master_company/list_company_name", {}, (err, _companies) => {
          if (err) {
            this.$notify({
              title: "所管会社のデータが読込めませんでした。",
              text: err,
              type: "error",
              duration: 10000,
            });
            return;
          }
              _companies.forEach(d=>{
                  d.value =d.val;
                })
              this.companylist = _companies;
              if(this.EditableUser == false){
                for(var k in this.companylist){
                  this.inventory_sub_search.company = this.companylist[k].val;
                  break;
                }
              }
              this.selectmode = "";
        });
      }else{
          var usercompany = Vue.localStorage.get("selectedCompany") || "";
          var userdepartment = Vue.localStorage.get("userDepartment") || "";
          this.select_list["company"] = [{val:usercompany,value:usercompany}];
          this.select_list["department"] = [{val:userdepartment,value:userdepartment}];  
          this.inventory_sub_search[this.Searchmap("company")] =  usercompany;
          this.inventory_sub_search[this.Searchmap("department")] =  userdepartment;
          this.selectmode = "department";
        }
      
    },
    SelectSearch(p){
      this.inventory_sub_search[this.Searchmap(p.id)] = p.value;
      if(p.value == ""){
        this.selectmode = this.get_empty_searchkey(p.id);
      }else{
        this.selectmode = p.id;
      }
    },
    onselectchange(mode){
      bus.$emit("inventory_sub_search",{search_data:this.inventory_sub_search})
      if(mode!="setonly"){
        setTimeout(() => {
          this.get_count_box_data();
        }, 300); 
      }
    },
    get_empty_searchkey(k){
      var map = {
        reporting_period:"reporting_period",
        company:"",
        department:"company",
        jurisdiction_classification:"department",
        team:"department",
        system:"jurisdiction_classification",
      };
      return map[k];
    },
   onselectmode(v,mode=""){
      switch (v){
        case "company":
            var target = {
              clear:["department","jurisdiction_classification","team","system"],
              open:["department"],
              disable:["jurisdiction_classification","team","system"],
              load_id:"department",
              api:"/master_belongs/list_department_use_subsearch",
              api_map:"belong",
              api_key:""
            };
            this.selectmodeproc(target,mode);
          break;
        case "department":
            var target = {
              clear:["jurisdiction_classification","team","system"],
              open:["jurisdiction_classification","team"],
              disable:["system"],
              load_id:"team",
              api:"/master_belongs/list_team_use_subsearch",
              api_map:"belong",
              api_key:""
              };
            this.selectmodeproc(target,mode);
          break;
        case "jurisdiction_classification":
          if(this.inventory_sub_search[this.Searchmap("jurisdiction_classification")] == "EUC・その他"){
            var target = {
              clear:["system"],
              open:["team"],
              disable:["system"],
              load_id:"team",
              api:"/master_belongs/list_team_use_subsearch",
              api_map:"belong",
              api_key:""
            };
            this.selectmodeproc(target,mode);
          }else{
            var target = {
              clear:["system","team"],
              open:["system"],
              disable:["team"],
              load_id:"system",
              api:"/master_system/list_system_name_use_subsearch",
              api_map:"system",
              api_key:""
            };
            this.selectmodeproc(target,mode);
          }
          break;
        case "system":
          this.onselectchange(mode); 
          break;
        case "team":
            var target = {
              clear:["system"],
              open:[],
              disable:[],              
              load_id:"system",
              api:"/master_system/list_system_name_use_subsearch",
              api_map:"system",
              api_key:""
            };
            this.selectmodeproc(target,mode);
          break;  
        case "reporting_period":
          this.onselectchange(mode); 
          break;          
        default:
            var target = {
              clear:["department","jurisdiction_classification","team","system"],
              open:["company"],
              disable:["department","jurisdiction_classification","team","system"],
              load_id:"",
              api:"",
              api_map:"",
              api_key:""
            };
            this.selectmodeproc(target,mode);
          break;
      }
    },
   selectmodeproc(target,mode){
      var api_subsearch = {};
      var temp = ""
      for(var i in this.searchkeys){

        if(target.clear.includes(this.searchkeys[i])){
          if(mode!="setonly"){
          this.inventory_sub_search[this.Searchmap(this.searchkeys[i])] = "";
          this.select_list[this.searchkeys[i]] = "";
          }
        }

        if(target.disable.includes(this.searchkeys[i])){
          this.selectdisable[this.searchkeys[i]] = true;
        }
        if(target.open.includes(this.searchkeys[i])){
          this.selectdisable[this.searchkeys[i]] = false;
        }
      
        if(target.api_map != ""){
          temp = this.Searchmap(this.searchkeys[i],target.api_map);
          if(temp != ""){
            api_subsearch[temp] = this.inventory_sub_search[this.Searchmap(this.searchkeys[i])];
          }
        }

      }
      if(this.selectdisable["jurisdiction_classification"] == false){
          this.select_list["jurisdiction_classification"] = [{val:"EUC・その他"},{val:"IT所管システム"}];
      }


      if(target.load_id != "" && target.api != ""){
        //api_keyが空ならばリストは空に
        var keyflag = false;
        if(target.api_key != ""){
          if(this.inventory_sub_search[this.Searchmap(target.api_key)] == ""){
            keyflag = true;
          }
        }
        if(keyflag != true){
          this.$ajax.post_cached_queued(target.api, {sub_search:api_subsearch}, (err, data) => {
            if (err) {
              this.$notify({
                title: "データが読込めませんでした。",
                text: err,
                type: "error",
                duration: 10000,
              });
              return;
            }
                this.select_list[target.load_id] = data;
                this.onselectchange(mode);
          });
        }else{
          this.select_list[target.load_id] = [];
          this.onselectchange(mode);
        }
      }else{
        this.onselectchange(mode);        
      }
    },
    
    Searchmap(v,mode = this.use_key){
      if(this.search_map == false){
        this.search_map =
          {common:{
            reporting_period:"reporting_period",
            company:"company",
            jurisdiction_classification:"jurisdiction_classification",
            department:"department",
            team:"team",
            system:"system",
          },
            inventory:{
            reporting_period:"reporting_period",
            company:"company",
            jurisdiction_classification:"jurisdiction_classification",
            department:"department_in_charge",
            team:"team_in_charge",
            system:"reporting_system",
          },
          device:{
            company:"company",
            jurisdiction_classification:"equipment_in_charge_classification",
            department:"equipment_in_charge_department",
            team:"equipment_in_charge_team",
            system:"equipment_in_charge_system_it",
          },
          cert:{
            company:"company",
            jurisdiction_classification:"jurisdiction_classification",
            department:"licensed_department",
            team:"license_jurisdiction_team",
            system:"license_jurisdiction_system",
          },
          belong:{
            company:"company",
            department:"department",
            team:"team",
          },
          system:{
            company:"company",
            department:"equipment_in_charge_department",
            team:"system_jurisdiction_team",
            system:"system_name",
          },
        }
      
        this.reverse_map = {};
        for(var k in this.search_map){
          for(var k2 in this.search_map[k]){
            this.reverse_map[this.search_map[k][k2]] = k2;
          }
        }
      }
      var temp = this.reverse_map[v];

      return this.search_map[mode][temp] || "";
    },
    //search End
  
    ApplyCouter(){
        switch(this.selectedTab){
          case 0:
              this.counterT1 = "ライセンス件数";
              this.counterT2 = "ライセンス総数";
              this.counterT3 = "使用総数";
              this.counterT4 = "残総数";
              this.counterU4 = "件";                        
              this.counterB1 = this.inventory_sub_search.number_of_devices_cert;
              this.counterB2 = this.inventory_sub_search.sum_license_number;
              this.counterB3 = this.inventory_sub_search.sum_effective_number;
              this.counterB4 = this.inventory_sub_search.sum_remaining_number;
            break;
          case 1:
              this.counterT1 = "紐付対象数";
              this.counterT2 = "紐付数";
              this.counterT3 = "未紐付数";
              this.counterT4 = "紐付率";     
              this.counterU4 = "";                 
              this.counterB1 = this.inventory_sub_search.number_of_installed_software_to_be_linked;
              this.counterB2 = this.inventory_sub_search.number_of_installation_software_licenses_attached;
              this.counterB3 = this.inventory_sub_search.number_of_unattached;
              this.counterB4 = this.inventory_sub_search.linkage_ratio;       
            break;
          default:
            break;
        }
    },
    addNewReport(){
      return this.$router.push({ name: "page_0071_inventory_report", params: {  seq_id:"new"} });
    },
    onTabChanged(index) {
      this.clearSearchFields();
      this.selectedTab = index;
      this.ApplyCouter();
      switch (index) {
        case 0:
          return this.$router.push( {path:"/inventory_certificate_list"});
          break;
        case 1:
          return this.$router.push( {path:"/inventory_pending_items"});
          break;
        default:
          break;
      }
    },
    judesubsearchmode(search){
      var flag = true;
      var map = this.certsearchkeys;
      for(var key in map){
        if(map[key] != "license_jurisdiction_team"){
          if(map[key] != "license_jurisdiction_system" || search["jurisdiction_classification"] != "EUC・その他"){
            if(search[map[key]]=="" || typeof search[map[key]]=="undefined"){
              flag = false;
            }
          }
        }
      }
      return flag;
    },

    get_count_box_data(){
      if(this.judesubsearchmode(this.inventory_sub_search)==false){
        this.inventory_sub_search.number_of_installed_software_to_be_linked = "";
        this.inventory_sub_search.number_of_installation_software_licenses_attached = "";
        this.inventory_sub_search.number_of_unattached = "";
        this.inventory_sub_search.linkage_ratio = "";
        this.inventory_sub_search.number_of_devices_cert = "";
        this.inventory_sub_search.sum_license_number = "";
        this.inventory_sub_search.sum_effective_number = "";
        this.inventory_sub_search.sum_remaining_number = "";     
        this.ApplyCouter();
        return;
      }
      if(this.loading_count_box_data == true){
        return;
      }
      var sub_search = {};
      var map = this.certsearchkeys;
      for(var k in map){
        sub_search[this.Searchmap(map[k],"inventory")] = this.inventory_sub_search[map[k]];
      }
      this.loading_count_box_data = true;
      this.$ajax.post("/" + this.api_name + "/statistical_output/",{sub_search:sub_search,listonly:true},(err, result) => {
          if (err) {
              this.$notify({
                title: "統計データの読込に失敗しました。",
                text: err,
                type: "error",
                duration: 10000,
              });
            }else{
              for(var k in result){
                this.inventory_sub_search[k] = result[k];
              }
              //team自動挿入
              // if(typeof result["team_in_charge"] != "undefined" && result["team_in_charge"] != ""){
              //   this.selvalues[this.Searchmap('team')] = result["team_in_charge"];
              //   this.onselectmode("team","setonly");
              // }
              this.loading_count_box_data = false;
              this.ApplyCouter();
            }
      });
    },
    // group0Updated(obj){
    //   if(obj.field == "reporting_period" || obj.field == "new_or_resubmit"){
    //     this.validateReportingPeriod()
    //   }
    // },
    // validateReportingPeriod(){
    //   var reporting_period = this.$store.state[this.stateCurrentEditing]["reporting_period"]
    //   var new_or_resubmit = this.$store.state[this.stateCurrentEditing]["new_or_resubmit"]

    //   if(new_or_resubmit == "新規"){
    //     if(this.reportingPeriodList.indexOf(reporting_period) > -1){
    //       // Show error, is new, but already exist
    //       this.group0Error = "The 新規/再提出 is 新規 but the 報告期分 alredy exist."
    //       this.allowToSubmit = false;
    //     }else{
    //       this.group0Error = false;
    //       this.allowToSubmit = true;
    //     }
    //   }else if(new_or_resubmit == "再提出"){
    //     if(this.reportingPeriodList.indexOf(reporting_period) < 0){
    //       // Show error, is update, but not exit
    //       this.allowToSubmit = false;
    //       this.group0Error = "The 新規/再提出 is 再提出 but the 報告期分 do not exist."
    //     }else{
    //       this.group0Error = false;
    //       this.allowToSubmit = true;
    //     }
    //   }else{
    //     this.allowToSubmit = false;
    //   }
    // },
    // numbersUpdated(obj){
    //   var total = parseInt(this.$store.state[this.stateCurrentEditing]["lack_of_license"]||0) 
    //             + parseInt(this.$store.state[this.stateCurrentEditing]["lost_license_certificate"]||0) 
    //             + parseInt(this.$store.state[this.stateCurrentEditing]["no_evidence_of_license_receipt"]||0) 
    //             + parseInt(this.$store.state[this.stateCurrentEditing]["other"]||0)
    //     if(total != this.counterB3){
    //       this.counterB3ErrorMessage = "※①～④の合計数と一致していません。"
    //     }else{
    //       this.counterB3ErrorMessage = null;
    //     }
    // },
    onConfirmDelete(mode){
      if(mode == "yes"){
        this.commonDelete(this);
      }
    },
    backToList(){
      return this.$router.push({ path: '/inventory_management', params: {} });
    },
    onInventorySaveCondirmed(mode){
      if(mode == "yes"){
        this.commonSaveInfo(this,this.api_name, {},(err,data_result)=>{
          if(err == null && data_result && data_result && data_result.seq_id > -1){
            this.saved_seq_id = data_result.seq_id
          }
        bus.$emit("confirmInventoryExport",{
          message: "棚卸報告の送信が完了しました。<br>報告結果をExcelで出力しますか？",
          title: "",
          yes_label: "はい(Excel出力)",
          no_label: "戻る(Excel出力無し)",
          yes_color:"primary",
          no_color:"",
          model_height:"50"
        });
        } );

      }else if(mode == "no"){
      }
    },
    onInventoryExportCondirmed(mode){
     if(mode == "yes"){
      bus.$emit("runInventoryExportDownloadModal",{
        message: "ファイルを出力しています。",
        on_complete_message:"出力が完了しました。",
        title: "出力",
        filter: {seq_id:this.saved_seq_id},
        sort: null,
        url:"/inventory_report/export_form_data/"
      });
      }else if(mode == "no"){
      }

    },
    onCloseExportFile(){},
    onLocalSaveInventory(){
      console.log("onLocalSave")
      bus.$emit("confirmInventorySave",{
        message: "棚卸報告を送信します。よろしいですか？",
        title: "",
        yes_label: "はい",
        no_label: "戻る",
        yes_color:"primary",
        no_color:"",
        model_height:"50"
      });
    },
  },
  mounted() {
    this.readOnly = false;
    this.$route.params.seq_id = "new";
    this.commonLoadRecord({},(err,result)=>{
      this.readOnly = false;
      // this.loadReportingPeriodList();
    });
    this.presetListSelectBox();

  },
  beforeMount() {
  },
  beforeDestroy() {
  },
};

</script>
<style scoped>

.report_field {
  width: 80%;
  height: 30px;
  background:#A6A6A6;
  text-align: start;
  color:#ffffff;
  line-height: 30px;
  margin-left: -10px;
}

.report_field_select{
float: left; 
line-height: 25px;
width: 230px;
}
.line1{
line-height: 25px;
width: 120px;
}
.textbox{
line-height: 25px;
}
.form1{
max-width: 550px;
margin-top: 30px;
margin-bottom: 30px;
}
.input:focus::-webkit-input-placeholder {
  color: transparent;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
.esma_form_label {
  background-color: #b4d5f1 !important;
  margin: 2px 0px !important;
  padding: 4px !important;
  font-size: 11px !important;
  text-align: center !important;
}
.esma_form_group {
  padding: 0px !important;
  margin: 0px !important;
}
.select-box {
  border: 1px solid #CCC;
  margin-top: 2px;
  margin-left: 5px;
  width :73%;
}
.select-box[disabled]{
  background-color: #cccccc;
  padding: 0px 6px 0px 6px;
}
.clearfloat::after {
	content: "";
	display: block;
	clear: both;
  overflow:auto;
}

</style>


// WEBPACK FOOTER //
// page_0070_inventory_tabs.vue?e158147e